import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

/**
 * Base API service for common CRUD operations.
 * Extend this for entity-specific services.
 */
@Injectable({ providedIn: 'root' })
export abstract class BaseApiService<T extends { id: string }> {
  protected readonly baseUrl = '/api';
  constructor(protected http: HttpClient) {}

  protected getAllRaw(collection: string): Observable<T[]> {
    return this.http.get<T[]>(`${this.baseUrl}/${collection}`);
  }
  protected getByIdRaw(collection: string, id: string): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${collection}/${id}`);
  }
  protected createRaw(collection: string, item: T): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${collection}`, item);
  }
  protected updateRaw(collection: string, id: string, item: Partial<T>): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${collection}/${id}`, item);
  }
  protected deleteRaw(collection: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${collection}/${id}`);
  }

  protected notSupported(method: string): never {
    throw new Error(`${method} is not supported by this service.`);
  }
}
